export default __webpack_public_path__ + "144dc16af674b0210551e42b12686279.svg";